import { useLanguage } from "../../../stores/LanguageStore";
import { ActionIcon, Tooltip } from "@mantine/core";
import { getNodeDetails } from "../workflows/CreateCampaign/flow/flowSettings";
import { IconBrandLinkedin } from "@tabler/icons-react";

const ModelTypeFilter = ({ filterType, setFilterType }) => {
  const lang = useLanguage((s) => s.language);

  const handleClick = (action) => {
    if (filterType.includes(action)) {
      setFilterType(filterType.filter((x) => x !== action));
    } else {
      setFilterType([...filterType, action]);
    }
  };

  return (
    <ActionIcon.Group style={{ zIndex: 100 }}>
      {["email", "linkedin_invitation", "linkedin_message", "sms", "smv"].map(
        (action) => {
          let details;
          let active = filterType.includes(action);
          if (action === "linkedin") {
            details = {
              icon: <IconBrandLinkedin size={20} style={{ borderRadius: 8 }} />,
              label: "LinkedIn",
              color: "blue",
            };
          } else {
            details = {
              ...getNodeDetails(action, { size: 18 }),
              label: lang.routes.models[action],
            };
          }

          return (
            <Tooltip key={action} label={details.label}>
              <ActionIcon
                key={action}
                variant="outline"
                size={42}
                color={active ? "#fff" : details.color}
                style={{
                  borderColor: "#00000012",
                  background: active ? details.color : "#fff",
                }}
                onClick={() => handleClick(action)}
              >
                {details.icon}
              </ActionIcon>
            </Tooltip>
          );
        },
      )}
    </ActionIcon.Group>
  );
};

export default ModelTypeFilter;
